import type { ComponentProps } from "@blocknote/react";
import classNames from "classnames";
import {
  SmallTextAccent,
  SmallTextMain,
  bgStyles,
  borderStyles,
  flexStyles,
  paddingStyles,
  pointerStyles,
  svgStyles,
  textStyles,
  useScrollIntoView,
} from "ui";

type Props = ComponentProps["SuggestionMenu"]["Item"];
export function Item({ item, onClick, isSelected }: Props) {
  const ref = useScrollIntoView<HTMLButtonElement>({
    trigger: isSelected,
    ifNeeded: true,
    intersectionSelector: "[data-ps-bs-suggestion-menu-root]",
    rootMargin: -100,
  });

  return (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      className={classNames(
        flexStyles.horiz100,
        flexStyles.alignCenter,
        paddingStyles.px100,
        paddingStyles.py050,
        borderStyles.radius050,
        textStyles.decorationNone,
        borderStyles.neutral200,
        bgStyles.neutral0,
        textStyles.neutral600,
        svgStyles.neutral600,
        pointerStyles.cursor,
        { [bgStyles.neutral200]: isSelected },
        { [borderStyles.neutral400]: isSelected },
      )}
    >
      {item.icon}
      <div className={classNames(flexStyles.vert, flexStyles.alignStart)}>
        <SmallTextAccent className={textStyles.left}>{item.title}</SmallTextAccent>
        <SmallTextMain className={textStyles.left}>{item.subtext}</SmallTextMain>
      </div>
    </button>
  );
}
